module.exports = __webpack_public_path__ + "static/3-e91630308e8f9c610220afb0facf748d.svg";